import React from 'react'

import HospitalHomeDoctorRegisterLayout from 'presentation/hospital/layouts/Home/DoctorRegister'

export default function HospitalHomeDirectorDoctorRegister() {
  return <HospitalHomeDoctorRegisterLayout />
}
